import { Col, Row } from "reactstrap";
import Btn from "../Button";

interface IFormFooterProps {
  // Button sizes (per breakpoint)
  closeBtnXs?: string;
  closeBtnMd?: string;
  closeBtnLg?: string;
  saveBtnXs?: string;
  saveBtnMd?: string;
  saveBtnLg?: string;
  // Labels
  closeLabel?: string;
  saveLabel?: any;
  // Colors
  closeColor?: string;
  saveColor?: string;
  // Classes
  containerClassName?: string;
  closeClassName?: string;
  saveClassName?: string;

  // Boolean
  isShowCloseBtn?: boolean;
  isSaveBtnDisabled?: boolean;

  // Callbacks
  onClose?: (values?: any) => void;
  onSave?: (values?: any) => void;
}

const FormFooter = ({
  onClose,
  onSave,
  closeBtnXs = "4",
  closeBtnMd = "3",
  closeBtnLg = "2",
  saveBtnXs = "4",
  saveBtnMd = "3",
  saveBtnLg = "2",
  closeLabel = "Close",
  saveLabel = "Save",
  closeColor = "secondary",
  saveColor = "primary",
  closeClassName = "f-12",
  saveClassName = "f-12",
  isShowCloseBtn = true,
  isSaveBtnDisabled = false,
  containerClassName = "d-flex justify-content-end m-auto",
}: IFormFooterProps) => {
  return (
    <Row className={containerClassName}>
      {isShowCloseBtn && (
        <Col xs={closeBtnXs} md={closeBtnMd} lg={closeBtnLg}>
          <Btn className={closeClassName} color={closeColor} onClick={onClose}>
            {closeLabel}
          </Btn>
        </Col>
      )}
      <Col xs={saveBtnXs} md={saveBtnMd} lg={saveBtnLg}>
        <Btn
          className={saveClassName}
          color={saveColor}
          onClick={onSave}
          disabled={isSaveBtnDisabled}
        >
          {saveLabel}
        </Btn>
      </Col>
    </Row>
  );
};

export default FormFooter;
